import { action, computed, observable } from 'mobx';
import Abstract from './abstract';

const PPT_TEMPLATE_UUIDS = ['MIXED_COURSEWARE_MAIN', 'KJ_MIX_DIGITAL_PPT'];

export class Layout extends Abstract {
  /* 全局菜单的折叠 */
  @observable collapsed = false;

  @action toggleMenu() {
    this.collapsed = !this.collapsed;
  }

  get mixedPptType() {
    const businessType = nx.get(this.root, 'content.current.businessType');
    const templateUuid = nx.get(this.root, 'content.current.templateUuid');
    return PPT_TEMPLATE_UUIDS.includes(templateUuid) && businessType === 'MIXED_COURSEWARE';
  }

  @computed get contentAside() {
    const contentSetting = this.root.content.setting;
    if (!contentSetting) return true;
    const { previewUrl, supportKnowledgePoint } = contentSetting;
    return Boolean(supportKnowledgePoint || previewUrl) && !this.mixedPptType;
  }

  @computed get contentSetting() {
    const contentSetting = this.root.content.setting;
    if (!contentSetting) return true;
    const { hasSetting } = contentSetting;
    return hasSetting
  }
}
